module.exports = __webpack_public_path__ + "img/legacy_7.09b26070.jpg";